/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatedSymbolPriceAlertDto
 */
export interface CreatedSymbolPriceAlertDto {
    /**
     * 
     * @type {string}
     * @memberof CreatedSymbolPriceAlertDto
     */
    id: string;
}

export function CreatedSymbolPriceAlertDtoFromJSON(json: any): CreatedSymbolPriceAlertDto {
    return CreatedSymbolPriceAlertDtoFromJSONTyped(json, false);
}

export function CreatedSymbolPriceAlertDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedSymbolPriceAlertDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function CreatedSymbolPriceAlertDtoToJSON(value?: CreatedSymbolPriceAlertDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

